import React from 'react';
import './sectionTwo.scss';

// Assuming you have 4 SVG images based on the design
import image1 from '../../../resources/smartCommand/1.svg';
import image2 from '../../../resources/smartCommand/2.svg';
import image3 from '../../../resources/smartCommand/3.svg';
import image4 from '../../../resources/smartCommand/4.svg';

const SectionTwo = () => {
	return (
		<div className='SmartCommandSectionTwo'>
			<div className="SmartCommandSectionTwo-content-wrapper">
				
				{/* Block 1 */}
				<div className="section-row">
					<div className="content-text">
						<h2 className="header2">Unified enterprise <br/>performance visibility</h2>
						<p className="txt-content">
							Monitor revenue, margin, inventory, working capital and operational performance through a connected, real-time view. Identify deviations from plan, surface emerging risks and opportunities, and see where performance needs attention across the enterprise.
						</p>
					</div>
					<div className="content-image">
						<img src={image1} alt='Unified enterprise performance visibility' />
					</div>
				</div>

				{/* Block 2 */}
				<div className="section-row reverse">
					<div className="content-text">
						<h2 className="header2">Understand what drives performance</h2>
						<p className="txt-content">
							Connect financial and operational signals to uncover the root causes of performance gaps. Understand the impact of decisions across revenue, margin, inventory and operations, with a clearer view of the business drivers behind enterprise results.
						</p>
					</div>
					<div className="content-image">
						<img src={image2} alt='Understand what drives performance' />
					</div>
				</div>

				{/* Block 3 */}
				<div className="section-row">
					<div className="content-text">
						<h2 className="header2">Predict risks. Evaluate <br/>scenarios. Prioritize actions.</h2>
						<p className="txt-content">
							Detect exceptions early and identify where intervention is needed. Analyze scenarios, evaluate trade-offs and quantify potential business impact to help teams prioritize the actions that improve performance, profitability and cash flow.
						</p>
					</div>
					<div className="content-image">
						<img src={image3} alt='Predict risks. Evaluate scenarios. Prioritize actions.' />
					</div>
				</div>

				{/* Block 4 */}
				<div className="section-row reverse">
					<div className="content-text">
						<h2 className="header2">From insight to measurable impact</h2>
						<p className="txt-content">
							Move beyond identifying performance gaps. Recommend interventions, assign accountable owners, track execution and compare expected versus actual outcomes to measure realized business value.
						</p>
						<p className="txt-footer">
							DETECT &rarr; EXPLAIN &rarr; RECOMMEND &rarr; ASSIGN &rarr; FOLLOW-UP &rarr; MEASURE IMPACT
						</p>
					</div>
					<div className="content-image">
						<img src={image4} alt='From insight to measurable impact' />
					</div>
				</div>

			</div>
		</div>
	);
}

export default SectionTwo;